var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"fill-height",style:({
    height: _vm.rowHeight,
  }),attrs:{"align":_vm.align,"justify":_vm.justify}},[_c('v-col',{attrs:{"align":_vm.align}},[_c('v-progress-circular',{attrs:{"color":_vm.color,"size":_vm.size,"width":_vm.width,"indeterminate":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }